import { TFPageContent, TFPageHeader } from '@tf/shared';
import { T } from '@tf/utils';

import { useProfileGroupsSchemas } from '@/core/api/profiles';
import { appStore } from '@/core/stores';
import { ProfileGroupsTable } from '@/components/profiles/ProfileGroupsTable';
import { AddProfileButton } from '@/components/shared';
import { AccountListRoute } from '@/routes/AccountListRoute';

export const ProfileRedirectRoute = () => {
	const { data: profileGroups, isLoading } = useProfileGroupsSchemas();
	const tenant = appStore.tenant?.get();

	if (isLoading) {
		return null;
	}

	if (profileGroups?.groups && profileGroups.groups.length > 0) {
		const firstGroup = profileGroups.groups[0];

		T.assertNotNullish(tenant, 'no tenant in appStore');

		return (
			<>
				<TFPageHeader tenant={tenant} title={firstGroup.label} toolbar={<AddProfileButton />} />
				<TFPageContent>
					<ProfileGroupsTable kinds={firstGroup.kinds} label={firstGroup.label} />
				</TFPageContent>
			</>
		);
	}

	return <AccountListRoute />;
};
